<template>
    <div class="modal-card">
        <header class="modal-card-head has-background-white">
            <h3 class="modal-card-title has-text-centered">
                Borrar mis datos
            </h3>
            <button
                class="delete"
                aria-label="Cerrar Modal"
                @click="$emit('close')"
            />
        </header>
        <section class="modal-card-body">
            <div class="px-6">
                <div class="columns is-mobile is-multiline is-vcentered">
                    <div class="column is-12-mobile">
                        <p
                            class="is-size-5 has-text-centered has-text-weight-light"
                        >
                            ¿Estás seguro de que deseas eliminar tus datos?
                        </p>
                    </div>
                </div>
            </div>
        </section>
        <footer
            class="modal-card-foot bt-none has-background-white is-justify-content-flex-end"
        >
            <button
                class="button"
                @click="$emit('close')"
                aria-label="Cerrar Modal"
                role="button"
            >
                Volver
            </button>
            <button
                class="button is-primary"
                aria-label="Eliminar mi usuario"
                :disabled="loading"
                role="button"
                @click="deleteSelf()"
            >
                Sí, borrar mis datos
            </button>
        </footer>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "SelfUserDelete",
    data() {
        return {
            loading: false,
        };
    },
    methods: {
        ...mapActions("userAuth", ["deleteSelf"]),
    },
};
</script>
